import { render, staticRenderFns } from "./ConvenioCard.vue?vue&type=template&id=acde36d6"
import script from "./ConvenioCard.vue?vue&type=script&lang=js"
export * from "./ConvenioCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports